﻿<template>

    <div class="pp" v-click-away="onClickAway">
        <button type="button" class="pp-toggle" :class="{ 'is-open': !isHidden }" :aria-expanded="!isHidden" aria-controls="pp-panel" @click="isHidden = !isHidden">
            <span class="pp-toggle-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>
            </span>
            <span class="pp-toggle-text">
                <span class="pp-toggle-label">Passengers</span>
                <span class="pp-toggle-value" :class="{ 'is-empty': Get_Passengers().length == 0 }">{{Passenger_Details()}}</span>
            </span>
            <svg class="pp-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
        </button>

        <div id="pp-panel" class="pp-panel" :hidden="isHidden">
            <!-- passengers already on the booking, which can be added to this trip -->
            <existing_passengers :passengers="get_Booking_Passengers()"></existing_passengers>

            <!-- who is travelling -->
            <template v-if="!add_ons">
                <p v-if="Seats_Left() >= 0" class="pp-seats">
                    {{ Seats_Left() === 1 ? '1 seat' : Seats_Left() + ' seats' }} left on the selected date
                </p>
                <ul class="pp-list">
                    <li v-for="passenger in CategorySort(age_cat.categories)" v-bind:key="passenger.name">
                        <passengers :pass=passenger @passenger_update="onPassengerUpdate"></passengers>
                    </li>
                </ul>
                <div class="pp-actions">
                    <button type="button" class="pp-clear" :disabled="Get_Passengers().length == 0" @click="Clear_Passengers()">Clear</button>
                    <button type="button" class="button button-standard xsmall pp-done" @click="isHidden = true">Done</button>
                </div>
            </template>

            <!-- add-on mode: choose which booked passengers take the add-on -->
            <template v-else>
                <p class="pp-seats">Select passengers</p>
                <ul class="pp-list">
                    <li v-for="(passenger, index) in get_Booking()?.passengers" :key="index">
                        <label class="pp-check">
                            <input type="checkbox" :checked="Add_On_Passenger(tour_id, index)" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded" @change="Toggle_Passenger(tour_id, index)">
                            {{passenger.first_name}}
                        </label>
                    </li>
                </ul>
                <div class="pp-actions">
                    <button type="button" class="button button-standard xsmall pp-done" @click="isHidden = true">Close</button>
                </div>
            </template>
        </div>
    </div>

</template>

<script lang="ts" src="./passenger_details.ts"></script>